import { useNavigate } from "react-router-dom"
import { ModalConfirm } from "src/shared/components/layout"
import Icon from "src/shared/icons"

interface CancelReservaModalProps {
    isOpen: boolean
    isEditMode: boolean
    onClose: () => void
}

const CancelReservaModal = ({ isOpen, isEditMode, onClose }: CancelReservaModalProps) => {
    const navigate = useNavigate()

    return (
        <ModalConfirm
            isOpen={isOpen}
            title={isEditMode ? "Abandonar la edición de reserva" : "Abandonar el registro"}
            description={
                isEditMode
                    ? `Si decides dar clic en "Continuar", ten en cuenta que no se registrará la actualización de datos que se editaron en la reserva.`
                    : "Si decides dar clic en 'Continuar', ten en cuenta que abandonarás el proceso y toda la información ingresada se perderá"
            }
            icon={<Icon name="Warning" color="var(--pink-ocupado)" />}
            iconTheme="danger"
            onCloseDialog={({ confirmed }) => {
                if (confirmed) navigate("/u/reservaciones/table")
                onClose()
            }}
        />
    )
}

export default CancelReservaModal
